<!-- navigation-app.component.html -->
<div class="navigation-container"
     [class.collapsed]="isCollapsed"
     [class.edit-mode-active]="isEditMode"
     appNavigationLayout
     [isCollapsed]="isCollapsed">

  <!-- Navigation path display -->


  <!-- Font Size Menu (shared between buttons) -->
  <mat-menu #fontSizeMenu="matMenu" class="font-size-menu">
    <div class="font-size-menu-header">Font Size</div>
    <button mat-menu-item *ngFor="let option of fontSizeOptions"
            (click)="setFontSize(option.value)"
            [class.selected-font-option]="currentFontSize === option.value">
      <div class="font-option-container">
        <span class="font-option-label"
              [style.fontSize]="option.value === 'medium' ? '14px' :
                                (option.value === 'large' ? '16px' : '12px')">
          {{ option.label }}
        </span>
        <mat-icon *ngIf="currentFontSize === option.value">check</mat-icon>
      </div>
    </button>
  </mat-menu>

  <!-- Main layout with panes side by side -->
  <div class="main-layout">
    <!-- Left side with pane1 and buttons -->
    <div class="left-side" [class.collapsed-left-side]="isCollapsed || isPaneOne_Collapsed">
      <!-- PANE 1 - When collapsed, this becomes the vertical sidebar -->
      <div class="pane1" [class.collapsed-pane1]="isCollapsed" [class.expanded-pane1]="isPaneTwo_Collapsed && !isCollapsed" [class.collapsed-pane1-only]="isPaneOne_Collapsed && !isCollapsed">
        <mat-toolbar class="pane-header">
          <!-- Layout Switcher slot -->
          <div class="layout-switcher-container">
            <ng-content></ng-content>
          </div>

          <!-- Show mode toggle buttons only if hideToggle is false and not collapsed -->
          <div *ngIf="!hideToggle && !isCollapsed" class="mode-toggle-container">
            <button mat-button
                    class="mode-toggle-button"
                    [class.active-mode]="p1Mode === 'topicwise'"
                    (click)="setMode('topicwise')">
              Topicwise
            </button>
            <button mat-button
                    class="mode-toggle-button"
                    [class.active-mode]="p1Mode === 'yearwise'"
                    (click)="setMode('yearwise')">
              Yearwise
            </button>
          </div>
          <!-- Show custom title if hideToggle is true and not collapsed -->
          <div *ngIf="hideToggle && !isCollapsed">
            <span>{{ customTitle || 'Navigation' }}</span>
          </div>
        </mat-toolbar>

        <!-- Content area -->
        <div class="pane-content">
          <!-- TOPICWISE VIEW -->
          <ng-container *ngIf="p1Mode==='topicwise'">
            <!-- Tree View for Subjects and Sections -->
            <div class="tree-container" *ngIf="!isCollapsed && !isPaneOne_Collapsed">
              <div *ngIf="isLoadingSubjects" class="loading-indicator">
                <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                <span>Loading subjects...</span>
              </div>

              <!-- Tree Actions Toolbar -->
              <div class="tree-actions-toolbar">
                <!-- Language Dropdown Button (for topicwise view) -->
                <div class="language-refresh-container">
                  <button mat-button [matMenuTriggerFor]="languageMenuTopicwise" class="language-dropdown" #topicwiseMenuTrigger="matMenuTrigger" (click)="$event.stopPropagation()">
                    <span>{{ selectedLanguage === 'bilingual' ? 'Bilingual' : (selectedLanguage === 'englishonly' ? 'English' : 'Hindi') }}</span>
                    <mat-icon>arrow_drop_down</mat-icon>
                  </button>
                  <mat-menu #languageMenuTopicwise="matMenu">
                    <button mat-menu-item (click)="onLanguageChange('englishonly', $event)">English</button>
                    <button mat-menu-item (click)="onLanguageChange('hindionly', $event)">Hindi</button>
                    <button mat-menu-item (click)="onLanguageChange('bilingual', $event)">Bilingual</button>
                  </mat-menu>

                  <!-- Enhanced expand/collapse all button with icon -->
                  <button mat-icon-button (click)="toggleAllNodes()" matTooltip="{{ isTreeExpanded ? 'Collapse All' : 'Expand All' }}">
                    <mat-icon>{{ isTreeExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
                  </button>
                  <!-- Refresh Button -->
                  <button mat-icon-button (click)="refreshTopicTree()" matTooltip="Refresh Topic Tree">
                    <mat-icon>refresh</mat-icon>
                  </button>
                </div>


                <!-- Edit Tree toggle - Only visible for internal users -->
                <div *ngIf="isInternalUser && !isCollapsed" class="edit-tree-toggle-container">
                  <mat-slide-toggle
                    class="edit-tree-toggle"
                    [checked]="isEditMode"
                    (change)="toggleEditMode($event)"
                    color="primary">
                    Edit Tree
                  </mat-slide-toggle>
                </div>


              </div>

              <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <!-- LEAF NODE (Sections) -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                               [matTreeNodePaddingIndent]="16"
                               [class.selected]="selectedSubItem === node.name"
                               class="level-2-node">
                  <div class="node-content-container">
                    <span (click)="onNodeSelect(node)" [innerHTML]="formatNodeName(node.name, node.hindiName || hindiNameMap[node.name] || node.name)"></span>

                    <!-- Edit button (only visible when edit mode is active and on hover) -->
                    <div *ngIf="isEditMode && canEditDeleteNode(node)" class="node-edit-container">


                      <!-- Edit options that appear when edit button is clicked -->
                      <div  class="edit-options-container">
                          <button *ngIf="canAddNode(node)" mat-icon-button
                                  class="add-node-button"
                                  (click)="addNode(node)"
                                  matTooltip="Add Topic">
                              <mat-icon>add_circle</mat-icon>
                          </button>
                          <button mat-icon-button
                                  class="rename-node-button"
                                  (click)="editNode(node)"
                                  matTooltip="Rename Topic">
                              <mat-icon>edit_note</mat-icon>
                          </button>
                          <button mat-icon-button
                                  class="delete-node-button"
                                  (click)="$event.preventDefault(); $event.stopPropagation(); deleteNode(node)"
                                  matTooltip="Delete Topic">
                              <mat-icon>delete</mat-icon>
                          </button>
                      </div>
                    </div>
                  </div>
                </mat-tree-node>

                <!-- PARENT NODE (Subjects) -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
                                      [class.selected]="(node.type === 'subject' && node.name === selectedSubject) ||
                 (node.type === 'section' && node.name === selectedSubItem)"
                                     class="level-1-node">
                  <div class="mat-tree-node">
                    <!-- Subject name -->
                    <div class="node-content-container">
                      <span (click)="onNodeSelect(node)" [innerHTML]="formatNodeName(node.name, node.hindiName || hindiNameMap[node.name] || node.name)" class="node-content"></span>

                      <!-- Edit button (only visible when edit mode is active and on hover) -->
                      <div *ngIf="isEditMode && canEditDeleteNode(node)" class="node-edit-container">

                        <!-- Edit options that appear when edit button is clicked -->
                        <div  class="edit-options-container">
                            <button *ngIf="canAddNode(node)" mat-icon-button
                                    class="add-node-button"
                                    (click)="addNode(node)"
                                    matTooltip="Add sub-item">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                            <button mat-icon-button
                                    class="rename-node-button"
                                    (click)="editNode(node)"
                                    matTooltip="Rename">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            <button mat-icon-button
                                    class="delete-node-button"
                                    (click)="$event.preventDefault(); $event.stopPropagation(); deleteNode(node)"
                                    matTooltip="Delete">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                      </div>
                    </div>

                    <!-- Toggle button -->
                    <button mat-button
                            *ngIf="hasChild(0, node) && node.type === 'subject'"
                            matTreeNodeToggle
                            [attr.aria-label]="'Toggle ' + node.name"
                            class="toggle-button"
                            (click)="$event.stopPropagation()">
                      {{treeControl.isExpanded(node) ? '▼' : '▶'}}
                    </button>
                  </div>

                  <!-- Child nodes (Sections) -->
                  <div [class.tree-invisible]="!treeControl.isExpanded(node)"
                       role="group" class="level-2-node-content"
                       [class.selected]="selectedSubItem === node.name">
                    <div *ngIf="isLoadingSections && selectedSubject === node.name" class="loading-indicator">
                      <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"></mat-progress-spinner>
                      <span>Loading sections...</span>
                    </div>
                    <ng-container matTreeNodeOutlet></ng-container>
                  </div>
                </mat-nested-tree-node>
              </mat-tree>

            </div>

            <!-- Collapsed view shows only text labels with better icons -->
            <div *ngIf="isCollapsed" class="collapsed-navigation">
              <!-- Expand button at the top -->
              <button mat-icon-button
                      class="expand-button"
                      (click)="toggleCollapse()"
                      matTooltip="Expand Navigation"
                      matTooltipPosition="right">
                <mat-icon>menu</mat-icon>
              </button>

              <!-- Mode indicator -->
              <div class="nav-mode-indicator">
                <mat-icon>{{ getModeIcon() }}</mat-icon>
                <span class="mode-label">{{ getModeLabel() }}</span>
              </div>

              <!-- Subject/Exam quick access -->
              <div class="collapsed-items-container scrollable-container">
                <!-- Determine which view mode we're in and show appropriate items -->
                <ng-container [ngSwitch]="p1Mode">
                  <!-- Topicwise mode -->
                  <ng-container *ngSwitchCase="'topicwise'">
                    <div *ngFor="let subject of p1Subjects; let i = index"
                         class="collapsed-item"
                         [class.selected]="selectedSubject === subject"
                         (click)="onSubjectSelect(subject)"
                         [matTooltip]="subject"
                         matTooltipPosition="right">
                      <span class="collapsed-label">{{ subject.charAt(0) }}</span>
                    </div>
                  </ng-container>

                  <!-- Yearwise mode -->
                  <ng-container *ngSwitchCase="'yearwise'">
                    <div *ngFor="let exam of p1YearwiseExams; let i = index"
                         class="collapsed-item"
                         [class.selected]="selectedYearwiseExam === exam"
                         (click)="onYearwiseExamClick(exam)"
                         [matTooltip]="exam"
                         matTooltipPosition="right">
                      <span class="collapsed-label">{{ exam.charAt(0) }}</span>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <!-- Collapsed view for isPaneOne_Collapsed state - similar to isCollapsed but for button 2 -->
            <div *ngIf="isPaneOne_Collapsed && !isCollapsed" class="collapsed-navigation">
              <!-- Expand button at the top -->
              <button mat-icon-button
                      class="expand-button"
                      (click)="togglePane1Collapse()"
                      matTooltip="Show Navigation"
                      matTooltipPosition="right">
                <mat-icon>menu</mat-icon>
              </button>



              <!-- Subject/Exam quick access -->
              <div class="collapsed-items-container scrollable-container">
                <!-- Determine which view mode we're in and show appropriate items -->
                <ng-container [ngSwitch]="p1Mode">
                  <!-- Topicwise mode -->
                  <ng-container *ngSwitchCase="'topicwise'">
                    <div *ngFor="let subject of p1Subjects; let i = index"
                         class="collapsed-item"
                         [class.selected]="selectedSubject === subject"
                         (click)="onSubjectSelect(subject)"
                         [matTooltip]="subject"
                         matTooltipPosition="right">
                      <span class="collapsed-label">{{ subject.charAt(0) }}</span>
                    </div>
                  </ng-container>

                  <!-- Yearwise mode -->
                  <ng-container *ngSwitchCase="'yearwise'">
                    <div *ngFor="let exam of p1YearwiseExams; let i = index"
                         class="collapsed-item"
                         [class.selected]="selectedYearwiseExam === exam"
                         (click)="onYearwiseExamClick(exam)"
                         [matTooltip]="exam"
                         matTooltipPosition="right">
                      <span class="collapsed-label">{{ exam.charAt(0) }}</span>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <!-- YEARWISE VIEW -->
          <ng-container *ngIf="p1Mode==='yearwise'">
            <!-- Tree View for Yearwise exams and papers -->
            <div class="tree-container" *ngIf="!isCollapsed && !isPaneOne_Collapsed">
              <div *ngIf="isLoadingTopics" class="loading-indicator">
                <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                <span>Loading exams...</span>
              </div>

              <!-- Tree Actions Toolbar -->
              <div class="tree-actions-toolbar" *ngIf="!isLoadingTopics">
                <!-- Language Dropdown Button (for yearwise view) -->
                <div class="language-refresh-container">
                  <button mat-button [matMenuTriggerFor]="languageMenuYearwise" class="language-dropdown" #yearwiseMenuTrigger="matMenuTrigger" (click)="$event.stopPropagation()">
                    <span>{{ selectedLanguage === 'bilingual' ? 'Bilingual' : (selectedLanguage === 'englishonly' ? 'English' : 'Hindi') }}</span>
                    <mat-icon>arrow_drop_down</mat-icon>
                  </button>
                  <mat-menu #languageMenuYearwise="matMenu">
                    <button mat-menu-item (click)="onLanguageChange('englishonly', $event)">English</button>
                    <button mat-menu-item (click)="onLanguageChange('hindionly', $event)">Hindi</button>
                    <button mat-menu-item (click)="onLanguageChange('bilingual', $event)">Bilingual</button>
                  </mat-menu>

                  <!-- Edit Tree toggle - Only visible for internal users -->
                  <div *ngIf="isInternalUser && !isCollapsed" class="edit-tree-toggle-container">
                    <mat-slide-toggle
                      class="edit-tree-toggle"
                      [checked]="isEditMode"
                      (change)="toggleEditMode($event)"
                      color="primary">
                      c
                    </mat-slide-toggle>
                  </div>

                  <!-- Refresh Button -->
                  <button mat-icon-button (click)="refreshTopicTree()" matTooltip="Refresh Topic Tree">
                    <mat-icon>refresh</mat-icon>
                  </button>

                  <!-- Add Subject Button - Only shown for internal users -->
                  <button mat-icon-button (click)="addSubject()" matTooltip="Create New Subject" *ngIf="isEditMode && isInternalUser">
                    <mat-icon>add_box</mat-icon>
                  </button>
                </div>

                <span class="spacer"></span>

                <!-- Enhanced expand/collapse all button with icon -->
                <button mat-icon-button (click)="toggleAllYearwiseNodes()" matTooltip="{{ isYearwiseTreeExpanded ? 'Collapse All' : 'Expand All' }}">
                  <mat-icon>{{ isYearwiseTreeExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
                </button>
              </div>

              <mat-tree [dataSource]="yearwiseDataSource" [treeControl]="yearwiseTreeControl">
                <!-- LEAF NODE (Papers) -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                               [matTreeNodePaddingIndent]="16"
                               [class.selected]="selectedYearwiseLower === node.name"
                               class="level-2-node">
                  <span (click)="onYearwiseNodeSelect(node)" [innerHTML]="formatNodeName(node.name, node.hindiName || hindiNameMap[node.name] || node.name)"></span>
                </mat-tree-node>

                <!-- PARENT NODE (Exams) -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasYearwiseChild"
                                     [class.selected]="selectedYearwiseExam === node.name"
                                     class="level-1-node">
                  <div class="mat-tree-node">
                    <!-- Exam name -->
                    <span (click)="onYearwiseNodeSelect(node)" [innerHTML]="formatNodeName(node.name, node.hindiName || hindiNameMap[node.name] || node.name)"></span>

                    <span class="spacer"></span>

                    <!-- Toggle button -->
                    <button mat-button
                            matTreeNodeToggle
                            [attr.aria-label]="'Toggle ' + node.name"
                            (click)="$event.stopPropagation()">
                      {{yearwiseTreeControl.isExpanded(node) ? '▼' : '▶'}}
                    </button>
                  </div>

                  <!-- Child nodes (Papers) -->
                  <div [class.tree-invisible]="!yearwiseTreeControl.isExpanded(node)"
                       role="group">
                    <div *ngIf="isLoadingSections && selectedYearwiseExam === node.name" class="loading-indicator">
                      <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"></mat-progress-spinner>
                      <span>Loading papers...</span>
                    </div>
                    <ng-container matTreeNodeOutlet></ng-container>
                  </div>
                </mat-nested-tree-node>
              </mat-tree>
            </div>

            <!-- Collapsed view - only show exam labels -->
            <div *ngIf="isCollapsed" class="collapsed-navigation">
              <!-- Expand button at the top -->
              <button mat-icon-button
                      class="expand-button"
                      (click)="toggleCollapse()"
                      matTooltip="Expand Navigation"
                      matTooltipPosition="right">
                <mat-icon>menu</mat-icon>
              </button>

              <!-- Mode indicator -->
              <div class="nav-mode-indicator">
                <mat-icon>{{ getModeIcon() }}</mat-icon>
                <span class="mode-label">{{ getModeLabel() }}</span>
              </div>

              <!-- Exams quick access -->
              <div class="collapsed-items-container scrollable-container">
                <div *ngIf="isLoadingTopics" class="loading-indicator">
                  <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                </div>

                <div *ngFor="let exam of p1YearwiseExams; let i = index"
                     class="collapsed-item"
                     [class.selected]="selectedYearwiseExam === exam"
                     (click)="onYearwiseExamClick(exam)"
                     [matTooltip]="exam"
                     matTooltipPosition="right">
                  <span class="collapsed-label">{{ exam.charAt(0) }}</span>
                </div>
              </div>
            </div>

            <!-- Collapsed view for isPaneOne_Collapsed state - similar to isCollapsed but for button 2 -->
            <div *ngIf="isPaneOne_Collapsed && !isCollapsed" class="collapsed-navigation">
              <!-- Expand button at the top -->
              <button mat-icon-button
                      class="expand-button"
                      (click)="togglePane1Collapse()"
                      matTooltip="Show Navigation"
                      matTooltipPosition="right">
                <mat-icon>menu</mat-icon>
              </button>

              <!-- Mode indicator -->
              <div class="nav-mode-indicator">
                <mat-icon>{{ getModeIcon() }}</mat-icon>
                <span class="mode-label">{{ getModeLabel() }}</span>
              </div>

              <!-- Exams quick access -->
              <div class="collapsed-items-container scrollable-container">
                <div *ngIf="isLoadingTopics" class="loading-indicator">
                  <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                </div>

                <div *ngFor="let exam of p1YearwiseExams; let i = index"
                     class="collapsed-item"
                     [class.selected]="selectedYearwiseExam === exam"
                     (click)="onYearwiseExamClick(exam)"
                     [matTooltip]="exam"
                     matTooltipPosition="right">
                  <span class="collapsed-label">{{ exam.charAt(0) }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Horizontal pane below pane1 with View and Settings buttons -->
      <div class="horizontal-buttons-pane" [class.collapsed-buttons-pane]="isCollapsed || isPaneOne_Collapsed">

        <!-- Add Subject Button - Only shown for internal users -->
        <button mat-icon-button (click)="addSubject()" matTooltip="Create New Subject" *ngIf="isInternalUser && isEditMode">
          <mat-icon>add_box</mat-icon>
        </button>
        <!-- Show full buttons when not collapsed and not in sidebar mode -->
        <div *ngIf="!isCollapsed && !isPaneOne_Collapsed" class="buttons-container">
          <!-- View button with font size menu -->
          <button mat-button class="action-button" matTooltip="View Options"
                  [matMenuTriggerFor]="fontSizeMenu" #fontSizeMenuTrigger="matMenuTrigger">
            <mat-icon>visibility</mat-icon>
            <span>View</span>
          </button>

          <button mat-button class="action-button" matTooltip="Settings" (click)="onSettingsButtonClick()">
            <mat-icon>settings</mat-icon>
            <span>Navigation Settings</span>
          </button>
        </div>

        <!-- Show only icons when sidebar is collapsed or in sidebar layout mode -->
        <div *ngIf="isCollapsed || isPaneOne_Collapsed" class="collapsed-buttons-container">
          <!-- View button with font size menu for collapsed mode -->
          <button mat-icon-button class="collapsed-action-button" matTooltip="View Options"
                  [matMenuTriggerFor]="fontSizeMenu" matTooltipPosition="right">
            <mat-icon>visibility</mat-icon>
          </button>

          <button mat-icon-button class="collapsed-action-button" matTooltip="Settings"
                  matTooltipPosition="right" (click)="onSettingsButtonClick()">
            <mat-icon>settings</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- PANE 2 - When navigation is collapsed, this becomes the left content area -->
    <div class="pane2"
         [class.expanded-pane2]="isCollapsed"
         [class.collapsed-pane2]="isPaneTwo_Collapsed && !isCollapsed"
         [class.expanded-pane2-full]="isPaneOne_Collapsed && !isCollapsed">
      <!-- PANE 2 HEADER -->
      <mat-toolbar class="pane-header">
        <div>
          <ng-container *ngIf="p1Mode === 'topicwise'">
            <span *ngIf="selectedSubItem" [innerHTML]="formatNodeName(selectedSubItem, hindiNameMap[selectedSubItem])"></span>
            <span *ngIf="!selectedSubItem && selectedSubject" [innerHTML]="formatNodeName(selectedSubject, hindiNameMap[selectedSubject])"></span>
            <span *ngIf="!selectedSubItem && !selectedSubject">Select a subject</span>
          </ng-container>
          <ng-container *ngIf="p1Mode === 'yearwise'">
            <span *ngIf="selectedYearwiseLower" [innerHTML]="formatNodeName(selectedYearwiseLower, hindiNameMap[selectedYearwiseLower])"></span>
            <span *ngIf="!selectedYearwiseLower && selectedYearwiseExam" [innerHTML]="formatNodeName(selectedYearwiseExam, hindiNameMap[selectedYearwiseExam])"></span>
            <span *ngIf="!selectedYearwiseLower && !selectedYearwiseExam">Select an exam</span>
          </ng-container>
        </div>


        <span class="spacer"></span>
      </mat-toolbar>

      <!-- PANE 2 CONTENT - Topics Tree -->
      <div class="pane-content">
        <!-- TOPICWISE TOPICS TREE -->
        <ng-container *ngIf="p1Mode === 'topicwise' && selectedSubItem">
          <div class="tree-container">
            <div *ngIf="isLoadingTopics" class="loading-indicator">
              <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
              <span>Loading topics...</span>
            </div>

            <!-- Topic Tree Actions -->
            <div class="tree-actions-toolbar" *ngIf="!isLoadingTopics">
              <span class="spacer"></span>

              <!-- Enhanced expand/collapse all button with icon -->
              <button mat-icon-button (click)="toggleAllTopicNodes()" matTooltip="{{ isTopicTreeExpanded ? 'Collapse All' : 'Expand All' }}">
                <mat-icon>{{ isTopicTreeExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
              </button>
            </div>

            <!-- Topic Tree -->
            <mat-tree [dataSource]="topicDataSource" [treeControl]="topicTreeControl">
              <!-- LEAF NODE (without children) - nodes that don't have children -->
              <mat-tree-node *matTreeNodeDef="let node"
                             matTreeNodePadding
                             [matTreeNodePaddingIndent]="16"
                             [class.selected]="selectedSubTopic === node.name ||
                                              (selectedTopic === node.name && !selectedSubTopic) ||
                                              (isParentOfSelectedSubtopic(node.name) && selectedSubTopic)">
                <div class="node-content-container">
                  <span (click)="onTopicNodeSelect(node)" [innerHTML]="formatNodeName(node.name, node.hindiName || hindiNameMap[node.name] || node.name)" class="node-content"></span>

                  <!-- Edit button (only visible when edit mode is active) -->
                  <div *ngIf="isEditMode && canEditDeleteNode(node)" class="node-edit-container">

                    <div class="edit-options-container">
                        <button *ngIf="canAddNode(node)" mat-icon-button
                                class="add-node-button"
                                (click)="addNode(node)"
                                matTooltip="Add sub-item">
                            <mat-icon>add_circle</mat-icon>
                        </button>
                        <button mat-icon-button
                                class="rename-node-button"
                                (click)="editNode(node)"
                                matTooltip="Rename">
                            <mat-icon>edit_note</mat-icon>
                        </button>
                        <button mat-icon-button
                                class="delete-node-button"
                                (click)="$event.preventDefault(); $event.stopPropagation(); deleteNode(node)"
                                matTooltip="Delete">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                  </div>
                </div>
              </mat-tree-node>

              <!-- PARENT NODE (with children) - only used for nodes that actually have children or are marked as having children -->
              <mat-nested-tree-node *matTreeNodeDef="let node; when: hasTopicChild"
                                    [class.selected]="(node.type === 'topic' && selectedTopic === node.name && !selectedSubTopic) ||
                                                     (node.type === 'subtopic' && selectedSubTopic === node.name) ||
                                                     (isParentOfSelectedSubtopic(node.name) && selectedSubTopic)"
                                    [class.has-children-no-visible]="node.hasChildren && (!node.children || node.children.length === 0)">
                <div class="mat-tree-node">
                  <!-- Topic name -->
                  <div class="node-content-container">
                    <span (click)="onTopicNodeSelect(node)" [innerHTML]="formatNodeName(node.name, node.hindiName || hindiNameMap[node.name] || node.name)" class="node-content"></span>

                    <!-- Edit button (only visible when edit mode is active) -->
                    <div *ngIf="isEditMode && canEditDeleteNode(node)" class="node-edit-container">
                      <div class="edit-options-container">
                          <button *ngIf="canAddNode(node)" mat-icon-button
                                  class="add-node-button"
                                  (click)="addNode(node)"
                                  matTooltip="Add sub-item">
                              <mat-icon>add_circle</mat-icon>
                          </button>
                          <button mat-icon-button
                                  class="rename-node-button"
                                  (click)="editNode(node)"
                                  matTooltip="Rename">
                              <mat-icon>edit_note</mat-icon>
                          </button>
                          <button mat-icon-button
                                  class="delete-node-button"
                                  (click)="$event.preventDefault(); $event.stopPropagation(); deleteNode(node)"
                                  matTooltip="Delete">
                              <mat-icon>delete</mat-icon>
                          </button>
                      </div>
                    </div>
                  </div>

                  <!-- Toggle button - only shown for nodes with hasChildren flag or visible children -->
                  <button mat-button
                          *ngIf="hasTopicChild(0, node)"
                          matTreeNodeToggle
                          class="toggle-button"
                          [attr.aria-label]="'Toggle ' + node.name"
                          (click)="$event.stopPropagation()">
                    {{topicTreeControl.isExpanded(node) ? '▼' : '▶'}}
                  </button>
                </div>

                <!-- Child nodes -->
                <div [class.tree-invisible]="!topicTreeControl.isExpanded(node)"
                     role="group">
                  <div *ngIf="isLoadingSubtopics && (selectedTopic === node.name || selectedSubTopic === node.name)" class="loading-indicator">
                    <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading children...</span>
                  </div>
                  <ng-container matTreeNodeOutlet></ng-container>
                </div>
              </mat-nested-tree-node>
            </mat-tree>
          </div>
        </ng-container>

        <!-- YEARWISE PAPERS CONTENT -->
        <ng-container *ngIf="p1Mode === 'yearwise' && selectedYearwiseLower">
          <div class="tree-container">
            <div *ngIf="isLoadingTopics" class="loading-indicator">
              <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
              <span>Loading years...</span>
            </div>

            <!-- Years List -->
            <div *ngIf="!isLoadingTopics && p2Years && p2Years[selectedYearwiseLower] && p2Years[selectedYearwiseLower].length > 0" class="years-list">
              <cdk-virtual-scroll-viewport itemSize="36" class="years-viewport">
                <div *cdkVirtualFor="let year of p2Years[selectedYearwiseLower]"
                     class="year-item"
                     [class.selected]="selectedYear === year"
                     (click)="onYearClick(year)">
                  <span>{{ year }}</span>
                </div>
              </cdk-virtual-scroll-viewport>
            </div>

            <!-- Empty state -->
            <div *ngIf="!isLoadingTopics && (!p2Years || !p2Years[selectedYearwiseLower] || p2Years[selectedYearwiseLower].length === 0)" class="empty-years">
              <span>No years available for this exam.</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
